<template>
  <v-card>



    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :search="search" :page.sync="page" :items="items" :headers="headers">
      <template v-slot:[`item.id`]="{ item }">
        {{ item.std_id }}
      </template>

      <template v-slot:[`item.name`]="{ item }">
        <v-btn text color="primary">
          <router-link class="profile-link" active-class="active" :exact="true"
            :to="{ name: 'StudentProfile', params: { id: item.std_id } }">
            <span class="table-tutor-name">{{ item.std_fname }} {{ item.std_lname }}</span>
          </router-link>
        </v-btn>
      </template>
      <template v-slot:[`item.guardian_name`]="{ item }">
        {{ item.gaurdian_fname }} {{ item.gaurdian_lname }}
      </template>
      <template v-slot:[`item.phone_number`]="{ item }">
        {{ item.gaurdian_contactno }}
      </template>
      <template v-slot:[`item.class_name`]="{ item }">
        {{ item.school_year.school_year_name }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-btn text color="#5E5EEA">{{ assessment_status_formatter(item.status) }}</v-btn>
      </template>
      <template v-slot:[`item.assessment`]="{ item }">
        <v-btn :loading="assigning.indexOf(item.id) !== -1" @click="bookAssessment(item)" color="primary" elevation="1"
          small v-if="permitObj.book_free_assesment">
          Book Free Assessment
        </v-btn>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-row>
          <v-col col="12" md="12" lg="12"> </v-col>
          <v-col col="12" md="12" lg="12">
            <v-btn :loading="assigning.indexOf(item.id) !== -1" @click="showDialog(item)" elevation="1" fab small
              v-if="permitObj.add_to_joined">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            <v-icon color="red" @click="confirmDelete(item)" v-if="permitObj.enquiry_delete">mdi-delete</v-icon>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
    <delete-dialog @success="deleteGroup" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete"
      :dialog="delete_dialog" title="Student"></delete-dialog>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card class="text-center" style="padding: 10px 15px">
        <v-card-title class="headline d-block text-center" color="#172B4D">Are your Sure?</v-card-title>
        <v-card-text>The student will be added to joined!</v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn :loading="confirmLoading" color="primary" dark @click="joinStudent">Confirm</v-btn>
          <v-btn color="default" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assessment_dialog" persistent max-width="500">
      <v-card style="padding: 10px 15px" :loading="loading">
        <v-form ref="form">
          <v-container>
            <fieldset>
              <legend class="heading ml-2">Book Free Assessment</legend>
              <v-row style="padding: 10px 15px">
                <v-col cols="12" sm="12" md="12">
                  <label class="custom-label">Select Class</label>
                  <v-select v-model="assessment.type" :error-messages="errors.type" :items="classes"
                    label="Select Class " placeholder="Select Class" solo single-line></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="custom-label">Select Tutor</label>
                  <v-autocomplete :error-messages="errors.tutor_id" v-model="assessment.tutor_id" :items="tutors" solo
                    label="Select Tutor" placeholder="Select Tutor" item-text="full_name" item-value="tutor_id">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="custom-label">Date</label>
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="assessment.date"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      {{ dateFormater(assessment.date) }}
                      <v-text-field v-model="formated.date" :error-messages="errors.date" label="Choose Date"
                        prepend-icon v-bind="attrs" solo v-on="on"></v-text-field>
                    </template>
                    <v-date-picker :first-day-of-week="1" v-model="assessment.date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(assessment.date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="custom-label">Start Time</label>
                  <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                    :return-value.sync="assessment.start_time" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="assessment.start_time" :error-messages="errors.start_time"
                        label="Choose Time" prepend-icon v-bind="attrs" solo v-on="on"></v-text-field>
                    </template>
                    <v-time-picker ampm-in-title v-if="menu2" v-model="assessment.start_time" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu2 = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.menu2.save(assessment.start_time)">
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="custom-label">End Time</label>
                  <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                    :return-value.sync="assessment.end_time" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="assessment.end_time" :error-messages="errors.end_time" label="Choose Time"
                        prepend-icon v-bind="attrs" solo v-on="on"></v-text-field>
                    </template>
                    <v-time-picker ampm-in-title v-if="menu3" v-model="assessment.end_time" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu3 = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.menu3.save(assessment.end_time)">
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-card-actions class="justify-space-right">
                <v-btn :loading="confirmLoading" color="primary" dark @click="bookStudent">Book</v-btn>
                <v-btn color="default" @click="assessment_dialog = false">Cancel</v-btn>
              </v-card-actions>
            </fieldset>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import DataTableMixin from "../../mixins/dataTable";
import Form from "../../utils/form/Form";
import DeleteDialog from "../Dialogs/DeleteDialog";
import DeleteRow from "../../mixins/deleteRow";
import { getPermitObjects } from '../../utils/allowedPermissions';

export default {
  name: "EnquiryTable",
  mixins: [DataTableMixin, DeleteRow],
  components: {
    DeleteDialog
  },
  data() {
    return {
      search: null,
      confirmLoading: false,
      dialog: false,
      dialogItem: "",
      errors: {},
      classes: ["Online", "In-center"],
      formated: { date: "" },
      assessment: {
        type: "",
        date: "",
        start_time: "",
        end_time: "",
        tutor_id: "",
      },
      tutors: [],
      assessment_dialog: false,
      assessment_dialogItem: "",
      assigning: [],
      loading: true,
      menu: false,
      menu2: false,
      menu3: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        { text: "SrNo.", sortable: true, value: "std_id" },
        { text: "Name", value: "name", sortable: true },
        { text: "Guardian Name", value: "guardian_name", sortable: true },
        { text: "Phone Number", value: "phone_number", sortable: true },
        { text: "Class", value: "class_name", sortable: true },
        { text: "Status", value: "status", sortable: true, align: " d-none" },
        { text: "Enquiry At", value: "creation_time", sortable: true },
        { text: "Book Assessment", value: "assessment", sortable: true },
        { text: "Action", value: "action", sortable: true },
        { text: "Full Name", value: "full_name", align: " d-none" },
      ],
    };
  },
  methods: {
    dateFormater(d) {
      console.log('Param Date: ', d);
      const today = new Date(d);
      const dd = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      const mm = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1;
      const yy = today.getFullYear();
      let fDate = dd + '-' + mm + '-' + yy;

      if (typeof fDate == 'string' && fDate === 'NaN-NaN-NaN') {
        this.formated.date = ''
      } else {
        this.formated.date = fDate;
      }

      console.log('Formated Date: ', fDate);

    },

    deleteGroup() {
      axios
        .get("enquiry_students/" + this.current_row.std_id)
        .then((response) => {
          // this.getItems()
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          this.getItems();
        })
        .catch((error) => {
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          // Toast.fire({
          //     icon: 'error',
          //     title: 'Cannot Deleted Linked Groups!',
          // })
        });
    },

    cancelDelete() {
      this.deleteConfirmLoading = false;
      this.delete_dialog = false;
    },

    showDialog(item) {
      this.dialog = true;
      this.dialogItem = item;
    },

    bookAssessment(item) {
      // console.log("bookAssessment", item);
      this.assessment_dialog = true;
      this.assessment_dialogItem = item;
    },

    bookStudent() {
      this.assessment.student = this.assessment_dialogItem;
      let form = new Form({
        ...this.assessment,
      });
      form
        .post(apiRoutes.students.bookAssessment)
        .then((response) => {
          this.assessment_dialog = false;
          Toast.fire({
            icon: "success",
            title:
              "An Assessment against " +
              this.assessment_dialogItem.full_name +
              " has been created.",
          });
          // this.$refs.form.reset();
          // console.log("response", response);
        })
        .catch((response) => {
          // console.log("response", response);
          if (response.status === 400) {
            this.errors = response.data;
          }
          if (response.status === 422) {
            this.errors = response.data.errors;
          } else {
            swal(error.response.data.message);
          }
          this.loading = false;
        });
    },

    joinStudent() {
      var item = this.dialogItem;

      this.assigning = [...this.assigning, item.std_id];
      axios.get(apiRoutes.students.joinUrl + item.std_id).then((response) => {
        this.dialog = false;
        this.assigning = [
          ...this.assigning.splice(this.assigning.indexOf(item.std_id), 1),
        ];
        this.getItems();
      });
    },

    getItems() {
      this.loading = true;
      axios
        .get(apiRoutes.students.assessmentUrl, { params: { type: "enquiry" } }).then((response) => {
          console.log('response 1')
          // console.log("response.data", response.data);
          this.tutors = response.data.tutors;
          console.log('response 2')
          this.formalizeTable(response.data);
          console.log('response 3')
          this.loading = false;

        });
    },

    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "APStudents";
      this.permitObj = getPermitObjects(links, pathName);
    }

  },
  mounted() {
    this.getItems();
  },
  created() {
    return this.getPermittedArray();
  },
};
</script>

<style scoped>
.justify-space-right {
  justify-content: flex-end;
}
</style>
